import { XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ConfirmationBoxProps {
  isOpen: boolean;
  message: string | React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  onCloseBox?: () => void;
  confirmText?: string;
  cancelText?: string;
  title?: string;
  danger?: boolean;
}

const ConfirmationBox: React.FC<ConfirmationBoxProps> = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
  onCloseBox,
  confirmText = "Confirm",
  cancelText = "Cancel",
  title = "Are you sure?",
  danger = false,
}) => {
  if (!isOpen) return null;

  const confirmButtonClass = danger
    ? "px-4 py-2 text-sm bg-salmon-300 text-white rounded-md hover:bg-salmon-400 w-1/2"
    : "px-4 py-2 text-sm bg-electrum text-white rounded-md hover:bg-electrum-300 w-1/2";

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-gray-800 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80 max-w-sm">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">{title}</h3>
          {onCloseBox && (
            <button
              onClick={onCloseBox}
              className="text-gray-500 hover:text-gray-700"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          )}
        </div>
        <div className="mb-4">{message}</div>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm border-2 border-electrum text-electrum rounded-md hover:bg-electrum-50 w-1/2"
          >
            {cancelText}
          </button>
          <button onClick={onConfirm} className={confirmButtonClass}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationBox;
